import { defineMessages } from 'react-intl'

const messages = defineMessages({
  cancellationPolicies: {
    id: 'global.cancellation-policies',
  },
  confirming: {
    id: 'reservation.confirming',
  },
  cancelYourBooking: {
    id: 'reservation.cancel-your-booking',
  },
})

export default messages
